var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("SettingBaseDataLov.table.basicInformation"))),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataLov.table.name"),
                prop: "meaning",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.meaning,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "meaning", $$v)
                  },
                  expression: "form.meaning",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataLov.table.code"),
                prop: "value",
              },
            },
            [
              _c("BjInput", {
                attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                model: {
                  value: _vm.form.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "value", $$v)
                  },
                  expression: "form.value",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataLov.table.sort"),
                prop: "orderSeq",
              },
            },
            [
              _c("BjInputNumber", {
                attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                model: {
                  value: _vm.form.orderSeq,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "orderSeq", $$v)
                  },
                  expression: "form.orderSeq",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }